import { Fragment, useMemo } from 'react'
import PropTypes from 'prop-types'
import {
  Hidden,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Typography,
  ListItemButton,
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import initials from 'initials'

const useStyles = makeStyles((theme) => ({
  listItemUser: {
    marginBottom: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(1),
    },
  },
  avatar: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(8),
      height: theme.spacing(8),
    },
  },
}))

const ListUserNavigation = ({ user, navigationItems }) => {
  const classes = useStyles()
  const { fullName, role, institute, avatarUri } = user
  const userInitials = useMemo(() => initials(fullName), [fullName])

  return (
    <List component="nav">
      <ListItem className={classes.listItemUser}>
        <ListItemAvatar>
          <Avatar alt={fullName} src={avatarUri} className={classes.avatar}>
            {userInitials}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={[
            <Fragment key="primary">
              <Typography>{fullName}</Typography>
              <Typography variant="caption">{role}</Typography>
            </Fragment>,
          ]}
          secondary={institute || null}
        />
      </ListItem>
      {navigationItems.map((item) => (
        <Hidden key={item.label} smDown={item.hideXsDown}>
          <ListItemButton onClick={item.handleClick} data-analytics={item.analytics}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItemButton>
        </Hidden>
      ))}
    </List>
  )
}

ListUserNavigation.propTypes = {
  user: PropTypes.shape({
    fullName: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    institute: PropTypes.string,
    avatarUri: PropTypes.string,
  }).isRequired,
  navigationItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.node.isRequired,
      handleClick: PropTypes.func.isRequired,
      analytics: PropTypes.string.isRequired,
      hideXsDown: PropTypes.bool,
    })
  ).isRequired,
}

export default ListUserNavigation
